import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// images
import logo from 'assets/images/logo.png';
import arrowLeft from 'assets/images/arrow-left.svg';
import arrowRight from 'assets/images/arrow-right.svg';
import iconSidebar0 from 'assets/images/Icon-sidebar-0.svg';
import iconSidebar1 from 'assets/images/Icon-sidebar-1.svg';
import iconSidebar2 from 'assets/images/Icon-sidebar-2.svg';
import iconSidebar3 from 'assets/images/Icon-sidebar-3.svg';
import iconSidebar4 from 'assets/images/Icon-sidebar-4.svg';

const { Sider } = Layout;

export const sidebarItemData = [
    {
        title: 'dashboard',
        key: 'admin-dashboard',
        icon: <img src={iconSidebar0} alt="" />,
        path: '/dashboard',
    },
    {
        title: 'teacher_page',
        key: 'teacher-management',
        icon: <img src={iconSidebar1} alt="" />,
        path: '/teachers',
    },
    {
        title: 'student_page',
        key: 'student-management',
        icon: <img src={iconSidebar2} alt="" />,
        path: '/students',
    },
    {
        title: 'class_page',
        key: 'class-management',
        icon: <img src={iconSidebar3} alt="" />,
        path: '/classes',
    },
    {
        title: 'learning_page',
        key: 'learning-management',
        icon: <img src={iconSidebar4} alt="" />,
        path: '/materials',
    },
];

const AppSidebar = (props) => {
    const { t } = useTranslation();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [openKeys, setOpenKeys] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [menuItems, setMenuItems] = useState(sidebarItemData);
    const authUser = useSelector((state) => state.auth.authUser);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (authUser.role === 2) {
            const teacherMenuItems = menuItems.filter(
                (item) => item.key !== 'teacher-management' && item.key !== 'admin-dashboard',
            );
            setMenuItems(teacherMenuItems);
        }
    }, []);

    useEffect(() => {
        let childIndex = -1;
        const selectedMenuItem = menuItems.find((item) => {
            if (item.children) {
                let tmp = item.children.findIndex((child) => location.pathname.startsWith(child.path));

                if (tmp >= 0) {
                    childIndex = tmp;
                    return true;
                }
                return false;
            } else {
                return location.pathname.startsWith(item.path);
            }
        });

        if (selectedMenuItem) {
            if (selectedMenuItem.children) {
                setSelectedKeys([selectedMenuItem.key, selectedMenuItem.children[childIndex].key]);
            } else {
                setSelectedKeys([selectedMenuItem.key]);
            }
        } else {
            setSelectedKeys([-1]);
        }
    }, [location]);

    const onToggleSubMenu = (key) => {
        if (openKeys.includes(key)) {
            setOpenKeys([]);
        } else {
            setOpenKeys([key]);
        }
    };

    return (
        <Sider className="app-sidebar" theme="light" width={276} trigger={null} collapsible collapsed={collapsed}>
            <div>
                <div className="logo-sidebar">
                    <img src={logo} alt="logo" className="logo ml-24 mr-24" />
                    <span className="text-logo">ABK COLLEGE</span>
                </div>
                <Menu mode="inline" className="sidebar-menu" selectedKeys={selectedKeys} openKeys={openKeys}>
                    {menuItems.map((item) => {
                        if (item.children && item.children.length) {
                            return (
                                <Menu.SubMenu
                                    key={item.key}
                                    icon={item.icon}
                                    title={item.title}
                                    onTitleClick={() => onToggleSubMenu(item.key)}
                                >
                                    {item.children.map((child) => (
                                        <Menu.Item
                                            key={child.key}
                                            icon={child.icon}
                                            onClick={() => navigate(child.path)}
                                            title={t(child.title)}
                                        >
                                            {t(child.title)}
                                        </Menu.Item>
                                    ))}
                                </Menu.SubMenu>
                            );
                        }
                        return (
                            <Menu.Item
                                key={item.key}
                                icon={item.icon}
                                onClick={() => navigate(item.path)}
                                title={t(item.title)}
                            >
                                {t(item.title)}
                            </Menu.Item>
                        );
                    })}
                </Menu>
            </div>
            <span className="menu-outlined" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? <img src={arrowRight} alt="" /> : <img src={arrowLeft} alt="" />}
            </span>
        </Sider>
    );
};

export default AppSidebar;
